module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.resources && _vm.resources.length === 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("No resources for this week.")])]) : _vm._e(), _vm._v(" "), (_vm.resources) ? _c('table', {
    staticClass: "course-table resources-table"
  }, [_c('thead'), _vm._v(" "), _c('tbody', _vm._l((_vm.resources), function(resource, index) {
    return _c('tr', {
      class: _vm.weekPosition(resource.week)
    }, [(_vm.localStorage.roles.indexOf('Student') === -1 && _vm.localStorage.roles.indexOf('CampusStudent') === -1) ? _c('td', [_c('i', {
      staticClass: "fa fa-remove remove-file",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteResource(resource.id, index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("Week " + _vm._s(resource.week))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(resource.description))]), _vm._v(" "), _c('td', [(resource.url.includes('amazonaws')) ? _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadFile(resource.url, resource.id)
        }
      }
    }, [_vm._v(_vm._s(resource.name))]) : _c('a', {
      attrs: {
        "href": resource.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(resource.name))])])])
  }))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b93ceea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Resources.vue
// module id = 1950
// module chunks = 2